/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

import { d } from './_utils';

import { commonProp7 } from './commonProp7';
import { commonProp5 } from './commonProp5';
import { commonProp6 } from './commonProp6';
import { commonProp4 } from './commonProp4';

export const shorts_crops : {[key: string]: Array<[string, string]>} = {
    p_type: [
        ["SHORTS", "\u0160ortky"],
        ["CROPS", "T\u0159\u00ed\u010dtvr\u0165\u00e1ky"],
    ],
    p_size: commonProp7,
    p_sex: commonProp5,
    p_brand: commonProp6,
    p_color: commonProp4,
};
